var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { Button } from '@atomic';
export var LoadMoreInfo = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: center;\n  text-decoration: underline;\n  cursor: pointer;\n  margin-top: 10px;\n  color: ", ";\n\n  font-size: 0.9rem;\n  font-weight: bold;\n"], ["\n  text-align: center;\n  text-decoration: underline;\n  cursor: pointer;\n  margin-top: 10px;\n  color: ", ";\n\n  font-size: 0.9rem;\n  font-weight: bold;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.corPrimaria;
});
export var NumberCircle = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: #49443c;\n  color: #ffffff;\n  display: flex;\n  width: 25px;\n  height: 25px;\n  align-items: center;\n  justify-content: center;\n  aspect-ratio: 1 / 1;\n  border-radius: 50%;\n  border: 2px solid #49443c;\n"], ["\n  background: #49443c;\n  color: #ffffff;\n  display: flex;\n  width: 25px;\n  height: 25px;\n  align-items: center;\n  justify-content: center;\n  aspect-ratio: 1 / 1;\n  border-radius: 50%;\n  border: 2px solid #49443c;\n"])));
export var ChecklistButton = styled(Button)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border-radius: 8px;\n  background-color: ", ";\n  border: 2px solid ", ";\n  color: ", ";\n\n  img {\n    color: ", ";\n    fill: ", ";\n    color-fill: ", ";\n    width: 20px;\n    height: 20px;\n    margin: auto;\n  }\n\n  span {\n    color: ", ";\n  }\n"], ["\n  border-radius: 8px;\n  background-color: ", ";\n  border: 2px solid ", ";\n  color: ", ";\n\n  img {\n    color: ", ";\n    fill: ", ";\n    color-fill: ", ";\n    width: 20px;\n    height: 20px;\n    margin: auto;\n  }\n\n  span {\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.backgroundColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.corPrimaria;
}, function (_a) {
    var theme = _a.theme;
    return theme.corPrimaria;
}, function (_a) {
    var theme = _a.theme;
    return theme.corPrimaria;
}, function (_a) {
    var theme = _a.theme;
    return theme.corPrimaria;
}, function (_a) {
    var theme = _a.theme;
    return theme.corPrimaria;
}, function (_a) {
    var theme = _a.theme;
    return theme.corPrimaria;
});
var templateObject_1, templateObject_2, templateObject_3;
